<template>

    <div class="GuideGreenDrinks col-12" :class="divClasses">
        <b>Green Drinks:</b><br>
        <div v-if="typeOfGD==='TwoWhatever'">
            <RecipeLink :RecipeID="1"></RecipeLink>(can be a third meal but preferably an hour after a meal)
        </div>
        <div v-if="typeOfGD==='OneAndOne'">
            <RecipeLink :RecipeID="1"></RecipeLink>(can be a third meal but preferably an hour after your healthy starch meal)
        </div>
        <div v-if="typeOfGD==='TwoStarch'">
            2 <RecipeLink :RecipeID="1"></RecipeLink>s: 1 an hour after each meal
        </div>
        <div v-if="typeOfGD==='Fast'">2 - 4 <RecipeLink :RecipeID="1"></RecipeLink>s throughout the day</div>
    </div>

</template>
<script>
import RecipeLink from './Recipe_Link';

export default {
    name: 'GuideGreenDrinks',
    components: {
        RecipeLink
    },
    props: {
        typeOfGD: String,
        divClasses: String
    },
    data() {
        return {
            Domain: this.$store.getters.SiteDomain()
        };
    }
};
</script>
